import { TranslationKeys } from '../types/i18n';

export const no: TranslationKeys = {
  common: {
    loading: 'Laster...',
    error: 'Feil',
    success: 'Suksess',
    save: 'Lagre',
    cancel: 'Avbryt',
    delete: 'Slett',
    edit: 'Rediger',
    create: 'Opprett',
    update: 'Oppdater',
    search: 'Søk',
    filter: 'Filter',
    sort: 'Sorter',
    export: 'Eksporter',
    import: 'Importer',
    close: 'Lukk',
    back: 'Tilbake',
    status: 'Status',
    active: 'Aktiv',
    created: 'Opprettet',
    lastLogin: 'Siste innlogging',
    editUserSettings: 'Rediger brukerinnstillinger',
    unknownError: 'Ukjent feil',
    next: 'Neste',
    previous: 'Forrige',
    submit: 'Send',
    reset: 'Tilbakestill',
    confirm: 'Bekreft',
    yes: 'Ja',
    no: 'Nei',
    new: 'Ny',
    of: 'av',
    information: 'Informasjon',
  },
  
  navigation: {
    home: 'Hjem',
    users: 'Brukere',
    settings: 'Innstillinger',
    userSettings: 'Brukerinnstillinger',
    profile: 'Profil',
    logout: 'Logg ut',
    dashboard: 'Dashbord',
    administration: 'Administrasjon',
    portal: 'Portal',
    forms: 'Skjemaer',
    streamWatch: 'Stream Overvåkning',
    txAdmin: 'TxAdmin',
    playerReports: 'Spillerrapporter',
    documentation: 'Dokumentasjon',
    discordApplications: 'Discord Søknader',
    dualFtpManager: 'Dual FTP Manager',
  },

  documentation: {
    title: 'Dokumentasjon',
    description: 'Opprett, administrer og organiser dokumentasjon for NBRP AEGIS',
    createNew: 'Ny dokumentasjon',
    uploadFiles: 'Last opp filer',
    upload: 'Last opp',
    backToDocuments: 'Tilbake til dokumenter',
    edit: 'Rediger',
    preview: 'Forhåndsvis',
    saving: 'Lagrer...',
    saveDocument: 'Lagre dokument',
    titleRequired: 'Tittel *',
    titlePlaceholder: 'Skriv inn en beskrivende tittel...',
    category: 'Kategori',
    categoryRequired: 'Kategori *',
    selectCategory: 'Velg kategori',
    tags: 'Tags',
    tagsRequired: 'Tags *',
    tagsPlaceholder: 'tag1, tag2, tag3',
    summary: 'Sammendrag',
    summaryRequired: 'Sammendrag *',
    summaryPlaceholder: 'En kort beskrivelse av dokumentet...',
    content: 'Innhold',
    contentPlaceholder: 'Skriv innholdet i dokumentet...',
    loadingContent: 'Laster innhold...',
    noContentAvailable: 'Ingen innhold tilgjengelig',
    searchPlaceholder: 'Søk i dokumenter...',
    allCategories: 'Alle kategorier',
    allStatuses: 'Alle statuser',
    published: 'Publisert',
    draft: 'Utkast',
    archived: 'Arkivert',
    documentsFound: 'dokumenter funnet',
    noDocuments: 'Ingen dokumenter',
    noDocumentsFiltered: 'Ingen dokumenter matchet søkekriteriene dine.',
    getStarted: 'Kom i gang ved å opprette ditt første dokument.',
    createDocument: 'Opprett dokument',
    readMore: 'Les mer →',
    viewDocument: 'Vis dokument',
    editDocument: 'Rediger dokument',
    deleteDocument: 'Slett dokument',
    deleteConfirm: 'Er du sikker på at du vil slette dette dokumentet?',
    uploadFile: 'Last opp en fil',
    dragDrop: 'eller dra og slipp',
    fileTypes: 'PDF, DOC, DOCX, TXT, MD, ODT, RTF opp til 60MB',
    cancel: 'Avbryt',
    uploading: 'Laster opp...',
    uploadDocument: 'Last opp dokument',
    loadingError: 'Feil ved lasting av dokumentinnhold.',
    saveError: 'Feil',
    saveErrorGeneric: 'Det oppstod en feil ved lagring av dokumentet',
    uploadError: 'Feil',
    uploadErrorGeneric: 'Det oppstod en feil ved opplasting av filen',
    fileTooLarge: 'Filen er for stor. Maksimal størrelse er 60MB.',
    fileTypeNotSupported: 'Filtype ikke støttet. Tillatte formater: PDF, DOC, DOCX, TXT, MD, ODT, RTF',
    supportedFormats: 'PDF, DOC, DOCX, TXT, MD, ODT, RTF opp til 60MB',
    download: 'Last ned',
    uploadTitle: 'Last opp dokument',
    uploadDescription: 'Last opp filer og legg til metadata for dokumentasjon',
    createDescription: 'Lag ny dokumentasjon for NBRP AEGIS systemet',
    editDescription: 'Oppdater eksisterende dokumentasjon',
    openInNewTab: 'Åpne i ny fane',
    previewWillShow: 'Forhåndsvisning vil vises her når innhold er tilgjengelig',
    visibleToRoles: 'Synlig for roller',
    veriagent: 'Veriagent',
    moderator: 'Moderator',
    developers: 'Utviklere',
    admin: 'Admin',
    superAdmin: 'Super Admin',
    standard: 'Standard',
    selectFile: 'Velg fil',
    categories: {
      userGuides: 'Brukerguider',
      apiDocumentation: 'API Dokumentasjon',
      systemDocumentation: 'Systemdokumentasjon',
      guidelines: 'Retningslinjer',
      procedures: 'Prosedyrer',
      technicalDocumentation: 'Teknisk dokumentasjon',
      faq: 'FAQ',
      training: 'Opplæring',
      meetingMinutes: 'Møtereferater',
    },
  },
  
  auth: {
    login: 'Logg inn',
    register: 'Registrer',
    logout: 'Logg ut',
    email: 'E-post',
    password: 'Passord',
    confirmPassword: 'Bekreft passord',
    forgotPassword: 'Glemt passord?',
    resetPassword: 'Tilbakestill passord',
    welcomeBack: 'Velkommen tilbake',
    createAccount: 'Opprett konto',
    alreadyHaveAccount: 'Har du allerede en konto?',
    dontHaveAccount: 'Har du ikke en konto?',
    adminLogin: 'Admin-pålogging',
    adminLoginDescription: 'Få tilgang til administrasjonspanelet',
    twoFactorVerification: 'Toveis autentisering',
    setupTwoFactor: 'Konfigurer toveis autentisering',
    setupTwoFactorDescription: 'Skann QR-koden med autentiseringsappen din',
    signIn: 'Logg inn',
    signingIn: 'Logger inn...',
    verificationCode: 'Bekreftelseskode',
    verify: 'Bekreft',
    verifying: 'Bekrefter...',
    scanQRCode: 'Skann denne QR-koden med autentiseringsappen din',
    backupCodes: 'Sikkerhetskoder',
    backupCodesDescription: 'Lagre disse kodene på et sikkert sted. Du kan bruke dem for å få tilgang til kontoen din hvis du mister autentiseringen.',
    firstName: 'Fornavn',
    lastName: 'Etternavn',
    enterCodeFromApp: 'Skriv inn koden fra autentiseringsappen din',
    completeSetup: 'Fullfør oppsett',
    completingSetup: 'Fullfører oppsett...',
    enterVerificationCode: 'Skriv inn 6-sifret kode fra autentiseringsappen din',
    changePassword: 'Endre passord',
    passwordChangeDescription: 'Du må endre ditt midlertidige passord før du kan fortsette',
    currentPassword: 'Nåværende passord',
    newPassword: 'Nytt passord',
    confirmNewPassword: 'Bekreft nytt passord',
    changingPassword: 'Endrer passord...',
    passwordChangeSuccess: 'Passord endret vellykket. Vennligst logg inn med ditt nye passord.',
    // CFX.re Authentication
    cfxLogin: 'Logg inn med CFX.re',
    cfxLoginInfo: 'CFX.re Autentisering',
    cfxLoginDescription: 'Du vil bli omdirigert til CFX.re for å autentisere med din FiveM konto.',
    continueWithCFX: 'Fortsett med CFX.re',
    cfxLoginFooter: 'Sikker autentisering drevet av FiveM/CFX.re',
    errorOAuthDenied: 'Autentisering ble avbrutt',
    errorMissingCode: 'Autentisering feilet - mangler autorisasjonskode',
    errorAuthFailed: 'Autentisering feilet - vennligst prøv igjen',
    errorGeneral: 'En feil oppstod under autentisering',
  },
  
  theme: {
    light: 'Lys',
    dark: 'Mørk',
    system: 'System',
    toggleTheme: 'Bytt tema',
  },
  
  language: {
    english: 'English',
    norwegian: 'Norsk',
    swedish: 'Svensk',
    changeLanguage: 'Bytt språk',
  },

  admin: {
    panel: 'Administrasjonspanel',
    overview: 'Dashboard Oversikt',
    management: 'Administrasjon',
    addNew: 'Legg til ny',
    recentActivity: 'Nylig aktivitet',
    quickActions: 'Hurtighandlinger',
    activeUsers: 'Aktive brukere',
    monthlySales: 'Månedlig salg',
    pendingOrders: 'Ventende bestillinger',
    reviewNeeded: 'Trenger gjennomgang',
    thisMonth: 'Denne måneden',
    thisWeek: 'Denne uken',
    lastMonth: 'Forrige måned',
    userRegistration: 'Brukerregistrering',
    paymentReceived: 'Betaling mottatt',
    generateReport: 'Generer rapport',
    uploadFiles: 'Last opp filer',
    fileUploads: 'Filopplastinger',
    orders: 'Bestillinger',
    analytics: 'Analyser',
    reports: 'Rapporter',
    orderManagement: 'Bestillingsadministrasjon',
    recentOrders: 'Nylige bestillinger',
    salesOverview: 'Salgsoversikt',
    downloadStatistics: 'Last ned statistikk',
    completed: 'Fullført',
    processing: 'Behandler',
    processed: 'Behandlet',
    view: 'Vis',
    download: 'Last ned',
    fileUploadManager: 'Filopplastingsadministrator',
    uploadNewFiles: 'Last opp nye filer',
    scriptFiles: 'Skriptfiler',
    executableFiles: 'Kjørbare filer',
    uploadScriptFiles: 'Last opp skriptfiler',
    uploadExecutables: 'Last opp kjørbare filer',
    dragAndDropScripts: 'Dra og slipp skriptfiler her',
    dragAndDropExecutables: 'Dra og slipp kjørbare filer her',
    selectFiles: 'Velg filer',
    recentUploads: 'Nylige opplastinger',
    uploadedAgo: 'Lastet opp for',
    firstName: 'Fornavn',
    lastName: 'Etternavn',
    role: 'Rolle',
    status: 'Status',
    user: 'Bruker',
    admin: 'Administrator',
    moderator: 'Moderator',
    developers: 'Utviklere',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    suspended: 'Suspendert',
    registered: 'Registrert',
    hoursAgo: 'timer siden',
    dayAgo: 'dag siden',
    salesChartsWillBeImplemented: 'Salgsdiagrammer vil bli implementert',
    downloadAnalyticsWillBeShown: 'Nedlastingsanalyser vil vises',
    versions: 'versjon',
    update: 'oppdater',
    version: 'versjon',
    versions_plural: 'versjoner',
    available: 'tilgjengelig',
    fileInformation: 'Filinformasjon',
    name: 'Navn',
    size: 'Størrelse',
    type: 'Type',
    unknown: 'Ukjent',
    noSales: 'Ingen salg',
    noOrders: 'Ingen bestillinger',
    noRecentActivity: 'Ingen nylig aktivitet',
    activityWillAppearHere: 'Aktivitet vil vises her',
    noFilesUploaded: 'Ingen filer lastet opp',
    useUploadAreasAbove: 'Bruk opplastingsområdene ovenfor',
    noOrdersYet: 'Ingen bestillinger ennå',
    ordersWillAppearHere: 'Bestillinger vil vises her',
    // Dashboard reports
    playerReports: 'Spillerrapporter',
    open: 'Åpen',
    resolved: 'Løst',
    noReports: 'Ingen rapporter',
    highPriorityReports: 'Høy prioritet rapporter',
    critical: 'Kritisk',
    high: 'Høy',
    allUnderControl: 'Alt under kontroll',
    totalReports: 'Totale rapporter',
    pendingReviews: 'Ventende gjennomganger',
    openReports: 'Åpne rapporter',
    resolvedReports: 'Løste rapporter',
    needAttention: 'Trenger oppmerksomhet',
    awaitingReview: 'Venter på gjennomgang',
    created: 'Opprettet',
    lastLogin: 'Siste innlogging',
    gdprCompliance: 'GDPR-samsvar',
    gdprConsentText: 'GDPR-samtykketekst',
    gdprConsentDate: 'GDPR-samtykkesdato',
    sendLoginCredentials: 'Send påloggingsopplysninger',
    userPermissions: 'Brukertillatelser',
    portalAccess: 'Portaltilgang',
    adminAccess: 'Administratortilgang',
    canAccessUserPortal: 'Kan bruke brukerportalen',
    canAccessAdminPanel: 'Kan bruke administrasjonspanelet',
    canManageUsers: 'Kan administrere brukere',
    superAdmin: 'Superadministrator',
    mainAdmin: 'Hovedadministrator',
    onlyMainAdmins: 'Kun hovedadministratorer kan endre brukertillatelser',
    permissionsUpdated: 'Brukertillatelser oppdatert',
    disable2FAConfirm: 'Er du sikker på at du vil deaktivere 2FA for {name}?\n\nDette vil:\n- Fjerne deres 2FA-beskyttelse\n- Tvinge dem til å sette opp 2FA igjen ved neste pålogging\n- Redusere kontosikkerheten\n\nSkriv "DISABLE" for å bekrefte:',
    disable2FA: 'Deaktiver 2FA',
    disable2FATooltip: 'Deaktiver 2FA for denne brukeren (kun super admin)',
    disable2FASuccess: '2FA har blitt deaktivert for {name}. De må sette det opp igjen ved neste pålogging.',
    disable2FAError: 'Feil ved deaktivering av 2FA for bruker',
    autoGeneratedPassword: 'Autogenerert Passord',
    autoPasswordInfo: 'Et sikkert midlertidig passord vil automatisk genereres for denne brukeren. De må endre det ved første innlogging før de setter opp 2FA.',
    temporaryPassword: 'Midlertidig Passord',
    copyPassword: 'Kopier',
    copyPasswordSuccess: 'Passord kopiert til utklippstavlen!',
    copyPasswordError: 'Kunne ikke kopiere passord til utklippstavlen',
    userCreatedSuccess: 'Bruker opprettet!',
    savePasswordInstructions: 'Vennligst kopier det midlertidige passordet nedenfor og gi det til brukeren. De må endre det ved første innlogging.',
    passwordSecurityWarning: '⚠️ Lagre dette passordet sikkert - det kan ikke gjenopprettes når denne dialogen lukkes.',
    copyPasswordFeedback: 'Passord kopiert!',
    
    // Reset Password functionality
    resetPassword: 'Tilbakestill Passord',
    resetPasswordTooltip: 'Generer nytt midlertidig passord for denne brukeren',
    resetPasswordConfirm: 'Er du sikker på at du vil tilbakestille passordet for {name}?\n\nDette vil:\n- Generere et nytt midlertidig passord\n- Tvinge dem til å endre passord ved neste pålogging\n- Deaktivere deres nåværende tilgang til de logger inn\n\nSkriv "RESET" for å bekrefte:',
    resetPasswordSuccess: 'Passord har blitt tilbakestilt for {name}. De må bruke det nye midlertidige passordet og endre det ved neste innlogging.',
    resetPasswordError: 'Feil ved tilbakestilling av passord for bruker',
    newTemporaryPassword: 'Nytt Midlertidig Passord',
    passwordResetNotice: 'Passord Tilbakestilt',
    passwordResetInstructions: 'Vennligst gi dette midlertidige passordet til brukeren. De må endre det umiddelbart ved innlogging.',
    requiresPasswordChange: 'Krever Passordendring',
    
    // Global Translations Management
    globalTranslationsTitle: 'Globale Oversettelser',
    globalSelectApplication: 'Velg Applikasjon',
    globalSearchTranslations: 'Søk i oversettelser...',
    globalKey: 'Nøkkel',
    globalEnglish: 'Engelsk',
    globalNorwegian: 'Norsk', 
    globalActions: 'Handlinger',
    globalNoTranslationsFound: 'Ingen oversettelser funnet',
    globalAdminApp: 'Admin',
    globalPortalApp: 'Portal',
    
    // Logs Management
    systemLogs: 'Systemlogger',
    superAdminOnly: 'Kun Super Admin',
    allCategories: 'Alle kategorier',
    userManagement: 'Brukeradministrasjon',
    authentication: 'Autentisering',
    twoFactorManagement: '2FA-administrasjon',
    systemSettings: 'Systeminnstillinger',
    security: 'Sikkerhet',
    apiAccess: 'API-tilgang',
    today: 'I dag',
    yesterday: 'I går',
    allTime: 'Alle tider',
    searchLogs: 'Søk i logger...',
    showingResults: 'Viser',
    logEntries: 'loggoppføringer',
    activityLog: 'Aktivitetslogg',
    loadingLogs: 'Laster logger...',
    noLogsFound: 'Ingen logger funnet',
    noLogsYet: 'Ingen logger ennå',
    tryDifferentSearch: 'Prøv et annet søkeord',
    logsWillAppear: 'Aktivitetslogger vil vises her',
    logs: 'Logger',
    
    // User Management Interface
    userInformation: 'Brukerinformasjon',
    basicInformation: 'Grunnleggende informasjon',
    fullName: 'Fullt navn',
    emailAddress: 'E-postadresse',
    securityAndAccess: 'Sikkerhet og tilganger',
    twoFactorAuth: 'To-faktor autentisering (2FA)',
    gdprConsent: 'GDPR-samtykke',
    given: 'Gitt',
    missing: 'Mangler',
    twoFactorEnabled: 'Brukeren har aktivert 2FA og har ekstra sikkerhet på kontoen.',
    twoFactorDisabled: 'Brukeren har ikke satt opp 2FA ennå. De vil bli bedt om å sette det opp ved neste innlogging.',
    twoFactorEnabledDesc: 'Brukeren har aktivert 2FA og har ekstra sikkerhet på kontoen.',
    twoFactorDisabledDesc: 'Brukeren har ikke satt opp 2FA ennå. De vil bli bedt om å sette det opp ved neste innlogging.',
    enabled: 'Aktivert',
    notEnabled: 'Ikke aktivert',
    twoFactorActivated: '🔒 Aktivert',
    twoFactorNotActivated: '⚠️ Ikke aktivert',
    disableTwoFactor: 'Deaktiver 2FA',
    gdprConsentGiven: 'Brukeren har gitt GDPR-samtykke',
    gdprConsentMissing: 'Brukeren har ikke gitt GDPR-samtykke ennå.',
    consentGiven: '✓ Gitt samtykke',
    consentMissing: '⚠️ Mangler samtykke',
    administratorAccess: 'Administratortilgang',
    userHasAdminAccess: 'Brukeren har tilgang til admin-panelet med følgende rettigheter:',
    deleteUserTooltip: 'Slett denne brukeren permanent (GDPR-kompatibel)',
    twoFactorAdministration: '2FA Administrasjon',
    twoFactorAdminInfo: '• Super administratorer kan deaktivere 2FA for alle brukere unntatt andre super administratorer\n• Administratorer kan ikke deaktivere sin egen 2FA\n• Når 2FA deaktiveres, må brukeren sette det opp på nytt ved neste innlogging\n• Dette er nyttig når brukere mister sin telefon eller autentiseringsapp',
    searchUsers: 'Søk etter brukere (navn, e-post, rolle)...',
    usersShowing: 'brukere',
    allUsers: 'Alle brukere',
    clickForUserInfo: 'Klikk for å se brukerinformasjon og administrere 2FA',
    noUsersFound: 'Ingen brukere funnet',
    tryDifferentSearchTerm: 'Prøv et annet søkeord',
    noUsersMatchSearch: 'Ingen brukere matcher søket ditt',
    basicTab: 'Grunnleggende',
    securityTab: 'Sikkerhet',
    permissionsTab: 'Tillatelser',
    activityTab: 'Aktivitet',
    gdprInformation: 'GDPR Informasjon',
    securityAndAuthentication: 'Sikkerhet og autentisering',
    passwordSecurity: 'Passord sikkerhet',
    lastPasswordChange: 'Siste passordendring',
    secured: 'Sikret',
    permissionsAndRights: 'Tillatelser og rettigheter',
    productViewing: 'Produktvisning',
    successfulLogin: 'Vellykket innlogging',
    twoFactorActivatedAction: '2FA aktivert',
    selfAdministered: 'Selv-administrert',
    accountCreated: 'Konto opprettet',
    byAdministrator: 'Av administrator',
    completeActivityLog: 'Komplett aktivitetslogg er tilgjengelig i system-loggene',
    unauthorizedAction: 'Du har ikke tillatelse til å deaktivere 2FA for denne brukeren.',
    confirmDeleteFile: 'Er du sikker på at du vil slette denne filen?',
    selectFiveMFiles: 'Klikk for å velge FiveM script-filer (.zip, .rar, .7z)',
    selectExecutableFiles: 'Klikk for å velge kjørbare filer (.exe, .msi, .zip)',
    usersWillAppearHere: 'Brukere vil vises her når de registreres',
    editUserSettings: 'Rediger brukerinnstillinger',
    deleteUser: 'Slett bruker',
    deleteUserPermanently: 'Slett bruker permanent (GDPR-kompatibel)',
    deleteUserConfirmMessage: 'GDPR-varsel: Er du sikker på at du vil slette {name}s konto permanent?\n\nDette vil:\n- Fjerne alle personopplysninger\n- Kan ikke angres\n- Bruker vil bli varslet via e-post\n\nSkriv "DELETE" for å bekrefte:',
    deleteUserSuccess: 'Bruker {name} har blitt slettet i samsvar med GDPR. Revisjonslogg opprettet.',
    deleteUserError: 'Feil ved sletting av bruker: {error}',
    confirmDeletion: 'DELETE',
    authenticating: 'Autentiserer...',
    loadingAdminPanel: 'Laster administrasjonspanel...',
    noActionsAvailable: 'Ingen handlinger tilgjengelige for din brukerrolle',
  },

  settings: {
    title: 'Innstillinger',
    description: 'Administrer kontoinnstillinger og sikkerhetspreferanser',
    accountInformation: 'Kontoinformasjon',
    email: 'E-post',
    name: 'Navn',
    role: 'Rolle',
    twoFactorStatus: '2FA Status',
    enabled: 'Aktivert',
    disabled: 'Deaktivert',
    changePassword: 'Endre passord',
    currentPassword: 'Nåværende passord',
    newPassword: 'Nytt passord',
    confirmNewPassword: 'Bekreft nytt passord',
    passwordRequirements: 'Minimum 16 tegn, maksimum 60. Må inneholde store bokstaver, små bokstaver, tall og spesialtegn',
    changingPassword: 'Endrer passord...',
    passwordsDoNotMatch: 'Passordene stemmer ikke overens',
    passwordTooShort: 'Passordet må være minst 16 tegn langt',
    passwordTooLong: 'Passordet kan ikke være mer enn 60 tegn langt',
    passwordNeedsUppercase: 'Passordet må inneholde minst én stor bokstav',
    passwordNeedsLowercase: 'Passordet må inneholde minst én liten bokstav',
    passwordNeedsNumber: 'Passordet må inneholde minst ett tall',
    passwordNeedsSpecial: 'Passordet må inneholde minst ett spesialtegn',
    passwordChangeSuccess: 'Passord endret vellykket',
    passwordChangeError: 'Feil ved endring av passord',
    twoFactorAuthentication: 'Toveis autentisering',
    twoFactorEnabledDescription: 'Toveis autentisering er aktivert for kontoen din.',
    twoFactorDisabledDescription: 'Aktiver toveis autentisering for å legge til et ekstra sikkerhetslag på kontoen din.',
    warning: 'Advarsel',
    disable2FAWarning: 'Hvis du deaktiverer 2FA eller mister tilgang til autentiseringsappen din, må du kontakte en super admin for å tilbakestille 2FA-innstillingene.',
    disable2FAConfirm: 'Er du sikker på at du vil deaktivere 2FA? Dette vil redusere kontosikkerheten.',
    disable2FA: 'Deaktiver 2FA',
    enable2FA: 'Aktiver 2FA',
    regenerateBackupCodes: 'Regenerer sikkerhetskoder',
    disable2FASuccess: '2FA har blitt deaktivert. Du må sette det opp igjen ved neste pålogging.',
    disable2FAError: 'Feil ved deaktivering av 2FA',
    securityInfo: 'Sikkerhetsinformasjon',
    twoFactorRequired: 'Toveis autentisering er påkrevd for alle admin-kontoer og kan ikke deaktiveres av brukere. Hvis du mister tilgang til autentiseringsappen din, kontakt en super admin for hjelp.',
    securelyConfigured: 'Sikkert konfigurert',
    pendingSetup: 'Venter på oppsett ved neste pålogging',
    pending: 'Venter',
    
    // TxAdmin Configuration
    txAdminConfiguration: 'TxAdmin Konfigurasjon',
    changeTxAdminPassword: 'Endre TxAdmin Passord',
    txAdminAccount: 'TxAdmin Konto',
    txAdminPasswordManagement: 'TxAdmin Passordbehandling',
    txAdminPasswordDescription: 'Endre TxAdmin-passordet ditt her. Dette vil oppdatere passordet ditt i TxAdmin-systemet og synkronisere det med AEGIS-kontoen din.',
    txAdminUsername: 'TxAdmin Brukernavn',
    currentTxAdminPassword: 'Nåværende TxAdmin Passord',
    newTxAdminPassword: 'Nytt TxAdmin Passord',
    enterTxAdminUsername: 'Skriv inn TxAdmin-brukernavnet ditt',
    enterCurrentTxAdminPassword: 'Skriv inn ditt nåværende TxAdmin-passord',
    enterNewPassword: 'Skriv inn ditt nye passord (minimum 8 tegn)',
    passwordRequirementsTxAdmin: 'Passordkrav:',
    passwordReq1: 'Minimum 8 tegn, maksimum 60 tegn',
    passwordReq2: 'Bruk en kombinasjon av bokstaver, tall og spesialtegn',
    passwordReq3: 'Velg et unikt passord du ikke har brukt andre steder',
    passwordReq4: 'Ditt nye passord vil bli brukt for TxAdmin panel-tilgang',
    passwordReqMinMax: 'Minimum 8 tegn, maksimum 60 tegn',
    passwordReqCombination: 'Bruk en kombinasjon av bokstaver, tall og spesialtegn',
    passwordReqUnique: 'Velg et unikt passord du ikke har brukt andre steder',
    passwordReqTxAdminAccess: 'Ditt nye passord vil bli brukt for TxAdmin panel-tilgang',
    changeTxAdminPasswordBtn: 'Endre TxAdmin Passord',
    changingTxAdminPassword: 'Endrer TxAdmin-passord...',
    usernameRequired: 'Brukernavn er påkrevd',
    newPasswordsDoNotMatch: 'Nye passord stemmer ikke overens',
    passwordMinLength: 'Passordet må være minst 8 tegn langt',
    passwordMaxLength: 'Passordet kan ikke være mer enn 60 tegn langt',
    txAdminPasswordChangeSuccess: 'TxAdmin-passord endret vellykket! Du kan nå bruke ditt nye passord for å få tilgang til TxAdmin.',
    
    // TxAdmin ModernTxAdmin Component
    sendAnnouncement: "Send Kunngjøring",
    sendAnnouncementToAllPlayers: "Send en kunngjøring til alle påloggede spillere",
    announcementPlaceholder: "Skriv din kunngjøring her...",
    announcementTextRequired: "Vennligst skriv en kunngjøringsmelding",
    sendingAnnouncement: "Sender kunngjøring...",
    announcementSent: "Kunngjøring sendt!",
    announcementFailed: "Kunne ikke sende kunngjøring",
    txAdminPasswordChangeError: 'Klarte ikke å endre TxAdmin-passord',
    
    // TxAdmin User Configuration
    txAdminConfigDescription: 'Konfigurer dine individuelle TxAdmin-legitimasjoner for å få tilgang til serveradministrasjonsfunksjoner. Disse er separate fra din NBRP AEGIS-konto.',
    tempPasswordNotice: '💡 Hvis du fikk et midlertidig passord fra en admin, kan du endre det i seksjonen "Endre TxAdmin Passord" nedenfor.',
    configurationStatus: 'Konfigurasjonsstatus',
    configuredForUsername: 'Konfigurert for brukernavn: {username}',
    notConfigured: 'Ikke konfigurert - TxAdmin-tilgang utilgjengelig',
    configured: 'Konfigurert',
    notConfiguredStatus: 'Ikke Konfigurert',
    setUpTxAdminCredentials: 'Sett opp TxAdmin-legitimasjon',
    updateCredentials: 'Oppdater legitimasjon',
    remove: 'Fjern',
    txAdminPassword: 'TxAdmin Passord',
    enterTxAdminPassword: 'Skriv inn TxAdmin-passordet ditt',
    securityNotes: 'Sikkerhetsnotater:',
    securityNote1: 'Dine legitimasjoner lagres sikkert og kryptert',
    securityNote2: 'Bare du kan få tilgang til din individuelle TxAdmin-konto',
    securityNote3: 'Disse legitimasjonene brukes kun for TxAdmin-autentisering',
    saveTxAdminCredentials: 'Lagre TxAdmin-legitimasjon',
    savingCredentials: 'Lagrer legitimasjon...',
    txAdminCredentialsSaved: 'TxAdmin-legitimasjon lagret vellykket!',
    txAdminCredentialsError: 'Klarte ikke å lagre TxAdmin-legitimasjon',
    removeTxAdminConfirm: 'Er du sikker på at du vil fjerne TxAdmin-legitimasjonen din? Du må sette den opp igjen for å få tilgang til TxAdmin.',
    txAdminCredentialsRemoved: 'TxAdmin-legitimasjon fjernet vellykket',
    
    // Additional TxAdmin translations
    passwordTooShortTxAdmin: 'Passordet må være minst 8 tegn langt',
    passwordTooLongTxAdmin: 'Passordet kan ikke være mer enn 60 tegn langt',
    fillAllRequiredFields: 'Vennligst fyll ut alle påkrevde felt',
    failedToSaveTxAdminCredentials: 'Klarte ikke å lagre TxAdmin-legitimasjon',
    failedToSaveCredentials: 'Klarte ikke å lagre legitimasjon',
    errorSavingCredentials: 'Feil ved lagring av legitimasjon',
    failedToRemoveTxAdminCredentials: 'Klarte ikke å fjerne TxAdmin-legitimasjon',
    errorRemovingCredentials: 'Feil ved fjerning av legitimasjon',
    unknownError: 'Ukjent feil',
    edit: 'Rediger',
    cancel: 'Avbryt',
    saving: 'Lagrer...',
    saveCredentials: 'Lagre legitimasjon',
    clear: 'Fjern',
    credentialsSecurelyStored: 'Dine legitimasjoner lagres sikkert og kryptert',
    onlyYouAccess: 'Bare du kan få tilgang til din individuelle TxAdmin-konto',
    credentialsOnlyForAuth: 'Disse legitimasjonene brukes kun for TxAdmin-autentisering',
    
    // CFG Editor
    cfgEditor: 'CFG-redigering',
    serverConfigurationEditor: 'Server konfigurasjon editor',
    saveFile: 'Lagre fil',
    saveFileShortcut: 'Lagre fil (Ctrl+S)',
    savingFile: 'Lagrer...',
    keyboardShortcuts: 'Tastatursnarveier:',
    saveFileShortcutDesc: 'Lagre fil',
    insertSpaces: 'Sett inn 4 mellomrom',
    cfgEditorHelpText: 'Endringer blir automatisk sikkerhetskopiert før lagring. Sørg for å teste konfigurasjonsenendringene dine før du starter serveren på nytt.',
    cfgPlaceholder: '# Server konfigurasjonsfil\n# Legg til server.cfg innhold her...',
    loadingCfgFile: 'Laster server.cfg fil...',
    failedToLoadCfg: 'Kunne ikke laste server.cfg fil',
    cfgSavedSuccessfully: 'server.cfg fil lagret vellykket',
    failedToSaveCfg: 'Kunne ikke lagre server.cfg fil',
    checkTxAdminConnection: 'Vennligst sjekk din TxAdmin tilkobling.',
    txAdminTempPasswordNote: 'Hvis du fikk et midlertidig passord fra en admin, kan du endre det i seksjonen "Endre TxAdmin Passord" nedenfor.',
    
    // TxAdmin Panel UI (oversettinger for TxAdmin-panelet)
    processing: "Behandler...",
    overview: "Oversikt",
    players: "Spillere",
    resources: "Ressurser",
    console: "Konsoll",
    logs: "Logger",
    playerHistory: "Spillerhistorikk",
    activeResources: "Aktive ressurser",
    playersOnline: "Spillere pålogget",
    serverPerformance: "Serverytelse",
    serverUptime: "Server oppetid",
    capacity: "Kapasitet",
    runningSmoothly: "Kjører jevnt",
    zeroTickWarning: "0ms tick",
    txAdminSetupRequired: "TxAdmin oppsett påkrevd",
    configureCredentials: "Konfigurer dine TxAdmin-legitimasjoner i brukerinnstillinger for å få tilgang til panelet",
    credentialsRequired: "TxAdmin-legitimasjoner påkrevd",
    needCredentialsDescription: "Du må konfigurere dine individuelle TxAdmin-legitimasjoner for å få tilgang til panelet.",
    goToUserSettings: "Gå til Brukerinnstillinger → TxAdmin for å konfigurere dine legitimasjoner.",
    checkAgain: "Sjekk igjen",
    connected: "Tilkoblet",
    connecting: "Kobler til",
    retry: "Prøv igjen",
    refreshData: "Oppdater data",
    actions: "Handlinger",
    start: "Start",
    stop: "Stopp",
    restart: "Start på nytt",
    started: "Startet",
    stopped: "Stoppet",
    starting: "Starter",
    stopping: "Stopper",
    restarting: "Starter på nytt",
    online: "Online",
    offline: "Offline",
    searchPlayers: "Søk spillere...",
    searchResults: "Søkeresultater",
    noPlayersFound: "Ingen spillere funnet som matcher søket ditt.",
    playerDetails: "Spillerdetaljer",
    ping: "Ping",
    uptime: "Oppetid",
    license: "Lisens",
    identifiers: "Identifikatorer",
    warn: "Advar",
    kick: "Spark ut",
    ban: "Utesteng",
    message: "Melding",
    directMessage: "Direktemelding",
    selectAction: "Velg handling",
    enterReason: "Skriv inn årsak...",
    reasonRequired: "Vennligst skriv inn en årsak",
    executeAction: "Utfør handling",
    executingAction: "Utfører handling...",
    actionCompleted: "Handling fullført",
    actionFailed: "Handling mislyktes",
    sendCommand: "Send kommando",
    enterCommand: "Skriv inn kommando...",
    sendingCommand: "Sender kommando...",
    commandSent: "Kommando sendt",
    commandFailed: "Kunne ikke sende kommando",
    serverConsole: "Serverkonsoll",
    serverLogs: "Serverlogger",
    loadingLogs: "Laster logger...",
    noLogs: "Ingen logger tilgjengelig",
    timestamp: "Tidsstempel",
    level: "Nivå",
    logMessage: "Melding",
    searchDatabase: "Søk database",
    searchByNameOrLicense: "Søk etter navn eller lisens...",
    searchingDatabase: "Søker i database...",
    playerHistoryDetails: "Spillerhistorikkdetaljer",
    filterPlayers: "Filtrer spillere",
    sortPlayers: "Sorter spillere",
    allPlayers: "Alle Spillere",
    onlinePlayers: "Online Spillere",
    offlinePlayers: "Offline Spillere",
    mostRecent: "Nyeste",
    oldest: "Eldste",
    alphabetical: "Alfabetisk",
    mostConnections: "Flest Tilkoblinger",
    lastSeen: "Sist Sett",
    totalConnections: "Totale Tilkoblinger",
    firstSeen: "Først Sett",
    loadingHistory: "Laster historikk...",
    noHistoryFound: "Ingen spillerhistorikk funnet",
    viewDetails: "Vis Detaljer",
    closeDetails: "Lukk Detaljer",
    reportPlayer: "Rapporter spiller",
    
    // Missing TxAdmin Panel UI properties
    connectedSuccessfully: "Vellykket tilkoblet til TxAdmin-panel",
    attemptingConnection: "Forsøker å etablere tilkobling til TxAdmin-server",
    rateLimited: "TxAdmin Ratebegrenset",
    rateLimitDescription: "Viser hurtigbufret data hvor tilgjengelig. Nye forespørsler vil være begrenset.",
    loadingResources: "Laster ressurser...",
    noResources: "Ingen ressurser lastet",
    resourceName: "Ressursnavn"
  },

  users: {
    title: "Brukerhåndtering",
    management: "Brukerhåndtering",
    createUser: "Opprett Bruker",
    editUser: "Rediger Bruker",
    deleteUser: "Slett Bruker",
    userDetails: "Brukerdetaljer",
    userList: "Brukerliste",
    searchUsers: "Søk brukere",
    noUsersFound: "Ingen brukere funnet",
    userCreated: "Bruker opprettet",
    userUpdated: "Bruker oppdatert",
    userDeleted: "Bruker slettet",
    confirmDelete: "Bekreft sletting",
    deleteConfirmation: "Er du sikker på at du vil slette denne brukeren?",
    basicInformation: "Grunnleggende informasjon",
    securitySettings: "Sikkerhetsinnstillinger",
    permissions: "Tillatelser",
    fullName: "Fullt navn",
    emailAddress: "E-postadresse",
    role: "Rolle",
    status: "Status",
    active: "Aktiv",
    inactive: "Inaktiv",
    lastLogin: "Siste innlogging",
    createdAt: "Opprettet",
    twoFactorAuth: "Tofaktor-autentisering",
    enabled: "Aktivert",
    disabled: "Deaktivert",
    gdprConsent: "GDPR samtykke",
    consentGiven: "Samtykke gitt",
    consentMissing: "Samtykke mangler"
  },

  roles: {
    admin: "Administrator",
    moderator: "Moderator", 
    user: "Veriagent",
    veriagent: "Veriagent",
    superAdmin: "Superadministrator",
    developer: "Utvikler",
    // Button/creation labels for each role
    createAdmin: "Administrator",
    createModerator: "Moderator",
    createUser: "User",
    createVeriagent: "Veriagent", 
    createDeveloper: "Utvikler"
  },

  forms: {
    title: "Skjemaer",
    description: "Opprett og administrer Discord-skjemaer for spillersøknader",
    createNew: "Opprett nytt skjema",
    createFirst: "Opprett ditt første skjema",
    loading: "Laster skjemaer...",
    noFormsTitle: "Ingen skjemaer opprettet ennå",
    noFormsDescription: "Opprett ditt første Discord-skjema for å begynne å samle inn spillersøknader.",
    submissions: "Innleveringer:",
    fields: "Felter:",
    discordBot: "Discord Bot:",
    created: "Opprettet:",
    view: "Vis",
    edit: "Rediger",
    delete: "Slett",
    close: "Lukk",
    deleteConfirmation: "Er du sikker på at du vil slette dette skjemaet? Alle innsendte søknader vil også bli slettet.",
    discordIntegrationTitle: "Discord integrasjonsstatus",
    discordBotConnection: "Discord Bot-tilkobling",
    discordIntegrationDescription: "Skjemaer vil automatisk bli lagt ut på Discord når de sendes inn",
    configureInSettings: "Konfigurer i Innstillinger → Discord Bot-innstillinger",
    viewFormModalTitle: "Vis skjema modal",
    viewFormModalDescription: "Denne modalen må ekstraheres fra page.tsx",
    unknownBot: "Ukjent Bot",
    // CreateWhitelistFormModal nøkler
    formName: "Skjemanavn",
    formNamePlaceholder: "Skriv inn skjemanavn...",
    formDescription: "Skjemabeskrivelse",
    formDescriptionPlaceholder: "Beskrivelse av skjemaet (valgfritt)...",
    welcomeMessage: "Velkomstmelding",
    welcomeMessagePlaceholder: "Velkomstmelding som vises på toppen av skjemaet...",
    selectDiscordBot: "Velg Discord Bot",
    selectBotPlaceholder: "Velg en Discord bot...",
    formFields: "Skjemafelt",
    addField: "Legg til felt",
    fieldLabel: "Feltlabel",
    fieldType: "Felttype",
    fieldRequired: "Påkrevd",
    fieldOptions: "Feltalternativer",
    fieldOptionsPlaceholder: "Skriv inn alternativer separert med komma...",
    removeField: "Fjern felt",
    textInput: "Tekstinndata",
    selectDropdown: "Nedtrekksliste",
    radioButtons: "Radioknapper",
    checkboxes: "Avkrysningsbokser",
    textarea: "Tekstområde",
    discordLanguage: "Discord-språk",
    discordLanguageDescription: "Velg språket for meldinger som vises på Discord",
    english: "Engelsk",
    norwegian: "Norsk",
    submitButtonText: "Send inn-knapp tekst",
    successMessage: "Suksessmelding",
    formPreview: "Skjemaforhåndsvisning",
    createForm: "Opprett skjema",
    cancel: "Avbryt",
    reset: "Tilbakestill",
    // Additional field types and form elements
    longText: "Lang tekst",
    number: "Nummer",
    email: "E-post",
    date: "Dato",
    dropdownSelection: "Nedtrekksliste",
    multipleChoice: "Flervalg",
    checkbox: "Avkrysningsboks",
    discordUsername: "Discord-brukernavn",
    characterName: "Karakternavn",
    enterCharacterName: "Skriv inn karakternavnet ditt...",
    botHandleSubmissions: "Denne botten vil håndtere skjemainnsendinger og varsler",
    fieldNumber: "Felt #",
    placeholderText: "Plassholdertekst",
    helperText: "Hjelpetekst for dette feltet...",
    required: "Påkrevd",
    options: "Alternativer",
    addOption: "Legg til alternativ",
    option: "Alternativ",
    untitledForm: "Uten tittel",
    selectOption: "Velg et alternativ",
    checkboxOption: "Merk av for dette alternativet",
    resetForm: "Tilbakestill skjema"
  },

  discordApplications: {
    title: "Discord Søknader",
    description: "Behandle søknader som kommer inn fra Discord bots",
    loading: "Laster søknader...",
    createNew: "+ Opprett Ny Søknadstype",
    createFirst: "Opprett Første Søknadstype",
    noApplicationTypes: "Ingen søknadstyper opprettet",
    noApplicationTypesDescription: "Opprett din første søknadstype for å motta søknader fra Discord.",
    noAccessDescription: "Du har ikke tilgang til å se noen søknadstyper enda.",
    searchPlaceholder: "Søk etter søker navn eller Discord ID...",
    showingResults: "Viser {count} av {total} søknader",
    noApplicationsFound: "Ingen søknader funnet for søket.",
    noApplicationsYet: "Ingen søknader ennå.",
    applicationsFromDiscord: "Søknader vil vises her når brukere sender inn via Discord.",
    applicantName: "Søkernavn",
    discordId: "Discord ID",
    submittedAt: "Sendt inn",
    status: "Status",
    applicationData: "Søknadsdata",
    reviewedAt: "Behandlet",
    pending: "Venter",
    approved: "Godkjent",
    rejected: "Avvist",
    approve: "✓ Godkjenn",
    reject: "✗ Avvis",
    // Create Modal
    createModalTitle: "Opprett Ny Søknadstype",
    createModalDescription: "Lag en ny type søknad som kan motta data fra en Discord bot",
    typeNameLabel: "Navn på søknadstype",
    typeNamePlaceholder: "f.eks. Whitelist Søknad, Staff Søknad...",
    selectBotLabel: "Velg Discord Bot (kun whitelist bots)",
    selectBotPlaceholder: "Velg en whitelist bot...",
    visibilityLabel: "Hvem kan se denne søknadstypen?",
    visibilityDescription: "Kun valgte roller vil kunne se og behandle søknader av denne typen",
    veriagent: "Veriagent",
    moderator: "Moderator",
    developers: "Developers",
    admin: "Admin",
    superAdmin: "Super Admin",
    cancel: "Avbryt",
    create: "Opprett",
    // Delete functionality
    deleteType: "Slett søknadstype",
    confirmDeleteType: "For å slette søknadstypen",
    typeDeleteToConfirm: "skriv DELETE for å bekrefte",
    deleteWarning: "Denne handlingen kan ikke angres. Hvis det finnes eksisterende søknader for denne typen, må de håndteres først.",
    // New application indicators
    newToday: "NY",
    pendingReview: "VENTER BEHANDLING",
    awaitingReview: "venter behandling"
  },

  whitelistForms: {
    title: "Hviteliste-skjemaer",
    description: "Administrer hviteliste-søknadsskjemaer",
    loading: "Laster skjemaer...",
    noFormsYet: "Ingen skjemaer opprettet ennå",
    noFormsYetDescription: "Opprett ditt første hviteliste-skjema for å begynne å motta søknader.",
    createFirst: "Opprett Første Skjema",
    createNew: "Opprett Nytt Skjema",
    searchPlaceholder: "Søk i skjemaer...",
    formName: "Skjemanavn",
    formType: "Skjematype",
    createdAt: "Opprettet",
    status: "Status",
    actions: "Handlinger",
    edit: "Rediger",
    delete: "Slett",
    view: "Vis",
    submissions: "Innsendinger",
    active: "Aktiv",
    inactive: "Inaktiv",
    draft: "Utkast",
    published: "Publisert",
    confirmDelete: "Er du sikker på at du vil slette dette skjemaet?",
    deleteWarning: "Denne handlingen kan ikke angres. Alle skjemainnsendinger vil gå tapt.",
    noSubmissions: "Ingen innsendinger ennå",
    viewSubmissions: "Vis Innsendinger"
  },

  streamWatch: {
    title: "StreamWatch",
    description: "Overvåk streamere på flere plattformer og få Discord-varsler",
    loading: "Laster...",
    loadingStreamers: "Laster streamere...",
    addStreamer: "Legg til Streamer",
    addFirstStreamer: "Legg til Din Første Streamer",
    searchPlaceholder: "Søk etter streamere...",
    // Filters
    allPlatforms: "Alle Plattformer",
    allStatus: "All Status",
    liveNow: "Live Nå",
    offline: "Offline",
    activeMonitoring: "Aktiv Overvåking",
    inactive: "Inaktiv",
    // Platform names
    platforms: {
      twitch: "Twitch",
      youtube: "YouTube Gaming",
      kick: "Kick"
    },
    // Status badges
    status: {
      inactive: "Inaktiv",
      live: "🔴 Live",
      offline: "Offline"
    },
    // Empty states
    noStreamersYet: "Ingen streamere lagt til ennå",
    noStreamersMatch: "Ingen streamere matcher dine filtre",
    noStreamersYetDescription: "Legg til din første streamer for å starte overvåking av livestreams",
    noStreamersMatchDescription: "Prøv å justere søket eller filterkriteriene dine",
    // Streamer info
    playing: "Spiller:",
    viewers: "seere",
    lastChecked: "Sist sjekket:",
    lastLive: "Sist live:",
    discordNotifications: "📢 Discord-varsler aktivert",
    delete: "🗑️ Slett",
    // Delete confirmation
    confirmDelete: "Er du sikker på at du vil slette {name} fra overvåking?",
    deleteError: "Kunne ikke slette streamer: {error}",
    deleteFailed: "Kunne ikke slette streamer. Vennligst prøv igjen.",
    // Modal
    addStreamerModal: {
      title: "Legg til Ny Streamer",
      description: "Legg til en ny streamer for å overvåke livestream-varsler",
      usernameLabel: "Streamer Brukernavn",
      usernamePlaceholder: "Skriv inn streamerens brukernavn",
      platformLabel: "Plattform",
      displayNameLabel: "Visningsnavn",
      displayNamePlaceholder: "Valgfritt visningsnavn for varsler",
      customMessageLabel: "Tilpasset Varselmelding",
      customMessagePlaceholder: "🔴 {displayName} er nå live på {platform}! Kom og se: {url}",
      customMessageHelp: "Tilgjengelige variabler: {displayName}, {platform}, {title}, {game}, {url}",
      activeMonitoringLabel: "Aktiv overvåking",
      discordNotificationsTitle: "Discord-varsler Aktivert",
      discordNotificationsDescription: "Denne streameren vil bruke \"Streaming\" Discord-boten. Konfigurer bot-innstillinger og kanal i Discord Bot-innstillinger.",
      selectBot: "Discord Bot (for varsler)",
      selectBotPlaceholder: "Velg en Discord bot...",
      channelLabel: "Discord Kanal-ID (for varsler)",
      channelPlaceholder: "Skriv inn Discord kanal-ID (f.eks. 123456789012345678)",
      streamerHelp: "Skriv inn det eksakte brukernavnet som det vises på plattformen (uten @ symbol)",
      cancel: "Avbryt",
      addStreamer: "Legg til Streamer",
      errors: {
        usernameRequired: "Brukernavn er påkrevd",
        platformRequired: "Vennligst velg en plattform",
        botRequired: "Vennligst velg en Discord bot",
        channelRequired: "Discord kanal-ID er påkrevd",
        addFailed: "Kunne ikke legge til streamer: {error}",
        tryAgain: "Kunne ikke legge til streamer. Vennligst prøv igjen."
      }
    }
  },

  autoStreamChecker: {
    title: "Stream Monitor",
    automaticChecking: "🤖 Automatisk sjekking hver 2. minutt",
    checkNow: "🔄 Sjekk Nå",
    checking: "⏳ Sjekker...",
    currentlyLive: "Live Nå",
    currentlyOffline: "Offline Nå",
    lastChecked: "Sist sjekket:"
  },

  discordAnnouncements: {
    title: "Discord Kunngjøringer",
    description: "Send changelog-oppdateringer og viktige meldinger til Discord-kanaler",
    tabs: {
      changelog: "Endringslogg",
      announcements: "Kunngjøringer",
      settings: "Innstillinger"
    },
    newChangelog: "Ny Endringslogg",
    newAnnouncement: "Ny Kunngjøring",
    changelogDescription: "Send changelog-oppdateringer til spillere via @CHANGELOG",
    announcementDescription: "Send viktige meldinger til alle via @everyone",
    colorSettings: "Fargeinnstillinger",
    colorSettingsDescription: "Velg farger for Changelog og Announcement meldinger",
    titleLabel: "Tittel",
    titleRequired: "Tittel *",
    titleChangelogPlaceholder: "f.eks. Changelog 04.03.2025",
    titleAnnouncementPlaceholder: "f.eks. Viktig Servermelding",
    contentLabel: "Innhold",
    contentRequired: "Innhold *",
    changelogContentPlaceholder: "[+] Lagt til muligheter for racing\n[+] Lagt til muligheter for drifting\n[+] Lagt til tre nye items på en lokasjon\n[-] Endring i materialer for pistol og pistolammunijon\n[&] Endret lokasjon og logo for Hayes",
    announcementContentPlaceholder: "Viktig informasjon som alle spillere må se...",
    changelogTip: "Bruk [+] for nye features, [-] for endringer, [&] for fixes",
    announcementTip: "Skriv viktig informasjon som alle spillere må se",
    discordBotLabel: "Discord Bot",
    discordBotRequired: "Discord Bot *",
    selectDiscordBot: "Velg Discord Bot",
    sendChangelog: "📤 Send Endringslogg",
    sendAnnouncement: "📤 Send Kunngjøring",
    sending: "Sender...",
    changelogColor: "📝 Endringslogg Farge",
    announcementColor: "📢 Kunngjøring Farge",
    discordPreview: "Discord Forhåndsvisning",
    discordPreviewDescription: "Slik vil meldingen se ut i Discord",
    colorPreviewDescription: "Slik vil fargene se ut i Discord",
    changelogPreview: "📝 Endringslogg Forhåndsvisning",
    announcementPreview: "📢 Kunngjøring Forhåndsvisning",
    changelogExample: "Endringslogg Eksempel",
    announcementExample: "Kunngjøring Eksempel",
    changelogExampleDescription: "Slik vil endringslogg-meldinger se ut",
    announcementExampleDescription: "Slik vil kunngjøring-meldinger se ut",
    colorsAutoSaved: "Fargene lagres automatisk",
    colorsAutoSavedDescription: "Når du velger en ny farge blir den automatisk lagret og brukt i fremtidige meldinger",
    noBotsConfigured: "Ingen Discord bots konfigurert",
    noBotsConfiguredDescription: "Du må opprette og konfigurere en Discord bot i Settings før du kan sende meldinger",
    changelogHelpers: "Changelog Hjelpere",
    addFeature: "Ny Feature",
    addChange: "Endring",
    addFix: "Fix",
    changelogHelpersDescription: "Klikk på knappene for å legge til changelog-formater automatisk",
    teamName: "👥 Team Navn",
    teamNameDescription: "Dette navnet vises i bunnteksten på alle Discord-meldinger",
    teamNamePlaceholder: "Team Nightbox",
    teamNameDefault: "Team Nightbox",
    discordSettings: "Discord Innstillinger",
    discordSettingsDescription: "Tilpass utseendet på Discord-meldingene dine",
    examples: {
      changelogTitle: "Changelog Eksempel",
      announcementTitle: "Announcement Eksempel",
      addedRacing: "Lagt til muligheter for racing",
      addedDrifting: "Lagt til muligheter for drifting",
      changedMaterials: "Endring i materialer for pistol",
      fixedLocation: "Endret lokasjon og logo for Hayes",
      announcementDescription: "Slik vil announcement-meldinger se ut"
    },
    errors: {
      noBotSelected: "Ingen Discord bot valgt",
      botNotConnected: "Valgt Discord bot er ikke tilkoblet",
      fillTitleContent: "Vennligst fyll inn tittel og innhold",
      channelNotConfigured: "kanal ID ikke konfigurert for denne boten. Gå til Settings → Discord Bot Settings og legg til kanal ID"
    },
    success: {
      changelogSent: "Changelog sendt til Discord!",
      announcementSent: "Announcement sendt til Discord!"
    },
    apiErrors: {
      discordError: "Feil ved sending til Discord. Sjekk bot-token og kanal-ID",
      generalError: "Feil ved sending til Discord"
    }
  },

  systemSettings: {
    title: "Innstillinger",
    description: "Konfigurer systeminnstillinger, integrasjoner og sikkerhetsalternativer",
    tabs: {
      txadmin: "TxAdmin Innstillinger",
      discord: "Discord Bot Innstillinger",
      webhook: "Webhook Innstillinger",
      violations: "Regelbrudd",
      todoCategories: "Todo Kategorier",
      translations: "Språkredigering"
    },
    txadmin: {
      title: "TxAdmin Integrasjonsinnstillinger",
      serverUrl: "TxAdmin Server URL",
      username: "Brukernavn",
      password: "Passord",
      testConnection: "Test Tilkobling",
      saveSettings: "Lagre Innstillinger",
      connected: "Tilkoblet Vellykket",
      server: "Server:",
      lastSync: "Sist synkronisert:",
      connectionFailed: "Tilkobling feilet:",
      saveFailed: "Lagring feilet:",
      settingsSaved: "TxAdmin innstillinger lagret vellykket",
      enterCredentials: "Vennligst skriv inn Server URL, brukernavn og passord før testing av tilkobling",
      credentialsRequired: "Server URL, brukernavn og passord er påkrevd"
    },
    discord: {
      title: "Discord Bot Innstillinger",
      selectBot: "Velg Bot å Konfigurere",
      addNewBot: "Legg til Ny Bot",
      sendFormMenus: "Send Skjema Menyer",
      syncAllCommands: "Synkroniser Alle Kommandoer",
      createNewBot: "Opprett Ny Discord Bot",
      editBot: "Rediger Discord Bot",
      manageForms: "Administrer Skjemaer for",
      botName: "Bot Navn",
      botNameRequired: "Bot navn er påkrevd",
      botNamePlaceholder: "f.eks. VIP Whitelist Bot, Personalskjemaer Bot",
      botNameDescription: "Gi Discord boten din et beskrivende navn for å identifisere formålet",
      botType: "Bot Type",
      botTypeRequired: "Bot Type *",
      clientId: "Discord Klient ID",
      clientIdPlaceholder: "Din Discord Applikasjon Klient ID",
      clientSecret: "Discord Klient Hemmelighet",
      botToken: "Discord Bot Token",
      botTokenPlaceholder: "Din Discord Bot Token",
      guildId: "Discord Guild ID",
      guildIdPlaceholder: "Din Discord Server ID",
      whitelistChannelId: "Whitelist Kanal ID",
      whitelistChannelIdPlaceholder: "Kanal ID for whitelist innleveringer",
      changelogChannelId: "Changelog Kanal ID",
      changelogChannelIdPlaceholder: "Kanal ID for changelog meldinger",
      changelogChannelDescription: "Standard kanal for @CHANGELOG meldinger",
      announcementChannelId: "Announcement Kanal ID",
      announcementChannelIdPlaceholder: "Kanal ID for announcement meldinger",
      announcementChannelDescription: "Standard kanal for @everyone meldinger",
      changelogRoleId: "Changelog Rolle ID",
      changelogRoleIdPlaceholder: "Rolle ID for @CHANGELOG omtaler",
      status: "Status",
      active: "Aktiv",
      inactive: "Inaktiv",
      testConnection: "Test Tilkobling",
      saveSettings: "Lagre Innstillinger",
      syncCommands: "Synkroniser Kommandoer",
      editSettings: "Rediger Innstillinger",
      deleteBot: "Slett Bot",
      connected: "Tilkoblet Vellykket",
      lastSync: "Sist synkronisert:",
      connectionFailed: "Tilkobling feilet:",
      saveFailed: "Lagring feilet:",
      settingsSaved: "Discord bot innstillinger lagret vellykket",
      botCreated: "Discord bot opprettet vellykket",
      botUpdated: "Discord bot oppdatert vellykket",
      botDeleted: "Discord bot slettet vellykket",
      enterCredentials: "Vennligst skriv inn Klient ID, Klient Hemmelighet og Bot Token før testing av tilkobling",
      deleteConfirm: "Er du sikker på at du vil slette denne boten? Denne handlingen kan ikke angres.",
      configure: "Konfigurer:",
      botTypes: {
        whitelist: {
          label: "Whitelist Bot",
          description: "Håndterer skjemainnleveringer og whitelist søknader",
          icon: "📋"
        },
        announcements: {
          label: "Announcement Bot",
          description: "Sender serveroppdateringer, changelog og kunngjøringer til Discord kanaler",
          icon: "📢"
        },
        streaming: {
          label: "Streaming Bot",
          description: "Overvåker og kunngjør når streamere går live på Twitch",
          icon: "🤖"
        }
      },
      setup: {
        steps: {
          step1: "Steg 1: Opprett Discord Applikasjon",
          step2: "Steg 2: Konfigurer Bot Innstillinger",
          step3: "Steg 3: Sett Tillatelser",
          step4: "Steg 4: Test Tilkobling",
          step5: "Steg 5: Deploy Kommandoer"
        },
        connectionStatus: {
          connected: "Bot er tilkoblet og klar",
          testOnline: "Tester tilkobling..."
        },
        applicationTypes: {
          title: "Discord Applikasjonstyper",
          description: "Velg type Discord applikasjon å opprette",
          instructions: {
            create: "Opprett en ny Discord applikasjon",
            link: "Koble til en eksisterende applikasjon",
            naming: "Bruk beskrivende navn for applikasjonene dine",
            warning: "Hold bot tokens sikre"
          }
        }
      },
      messages: {
        createSuccess: "Discord bot opprettet vellykket",
        createError: "Kunne ikke opprette Discord bot",
        updateSuccess: "Discord bot oppdatert vellykket",
        updateError: "Kunne ikke oppdatere Discord bot",
        deleteSuccess: "Discord bot slettet vellykket",
        deleteError: "Kunne ikke slette Discord bot",
        saveSuccess: "Innstillinger lagret vellykket",
        saveError: "Kunne ikke lagre innstillinger"
      }
    },
    webhook: {
      title: "Webhook Innstillinger",
      language: "Språk",
      languageDescription: "Velg språk for webhook notifikasjoner",
      english: "Engelsk",
      norwegian: "Norsk",
      enabled: "Aktivert",
      disabled: "Deaktivert",
      testLanguage: "Test Språk",
      saveSettings: "Lagre Innstillinger",
      settingsSaved: "Webhook innstillinger lagret vellykket",
      testSent: "Test melding sendt!"
    },
    translations: {
      title: "Språkredigering",
      description: "Rediger og administrer oversettelser for engelsk og norsk språk",
      searchPlaceholder: "Søk i oversettelsesnøkler...",
      keyColumn: "Oversettelsesnøkkel",
      englishColumn: "Engelsk",
      norwegianColumn: "Norsk",
      saveChanges: "Lagre Endringer",
      saving: "Lagrer oversettelser...",
      saved: "Oversettelser lagret!",
      resetChanges: "Tilbakestill Endringer",
      confirmReset: "Er du sikker på at du vil tilbakestille alle ulagrede endringer?",
      noChanges: "Ingen endringer å lagre",
      expandAll: "Ekspander Alle",
      collapseAll: "Lukk Alle",
      filterBySection: "Filtrer på seksjon",
      allSections: "Alle Seksjoner",
      changesDetected: "Du har ulagrede endringer",
      expandSection: "Ekspander seksjon",
      collapseSection: "Lukk seksjon",
      noTranslationsFound: "Ingen oversettelser funnet som samsvarer med søkekriteriene"
    },
    common: {
      cancel: "Avbryt",
      save: "Lagre",
      delete: "Slett",
      edit: "Rediger",
      create: "Opprett",
      close: "Lukk",
      loading: "Laster...",
      saving: "Lagrer...",
      testing: "Tester...",
      success: "Suksess",
      error: "Feil",
      warning: "Advarsel",
      confirm: "Bekreft",
      activate: "Aktiver",
      deactivate: "Deaktiver"
    }
  },

  reports: {
    title: "Spillerrapport System",
    subtitle: "Administrer og spor spillerrapporter med bevis og tilknyttede hendelser",
    createNewReport: "Opprett Ny Rapport",
    refresh: "Oppdater",
    refreshing: "Oppdaterer...",
    viewDetails: "Vis Detaljer",
    linkedReports: "Tilknyttede Rapporter",
    searchPlaceholder: "Søk i rapporter etter rapportør, spiller, emne eller beskrivelse...",
    resultsCount: "av",
    resultsText: "rapporter",
    loadingReports: "Laster rapporter...",
    noReportsFound: "Ingen spillerrapporter funnet",
    noReportsFoundDescription: "Opprett en ny rapport for å komme i gang",
    noSearchResults: "Ingen rapporter samsvarer med søkekriteriene dine",
    noSearchResultsDescription: "Prøv å justere søkeordene dine",
    attachments: "vedlegg",
    attachmentsPlural: "vedlegg",
    linkedReport: "tilknyttet rapport",
    linkedReportsPlural: "tilknyttede rapporter",
    violation: "regelbrudd",
    violationsPlural: "regelbrudd",
    alreadyAdded: "Allerede lagt til",
    selectedViolations: "Valgte Regelbrudd",
    updateSuccess: "Rapport oppdatert vellykket",
    updateError: "Kunne ikke oppdatere rapport",
    deleteConfirm: "Er du sikker på at du vil slette rapport",
    deleteSuccess: "Rapport slettet vellykket",
    deleteError: "Kunne ikke slette rapport",
    createSuccess: "Rapport opprettet vellykket",
    createError: "Kunne ikke opprette rapport",
    genericError: "Vennligst prøv igjen",
    unknownError: "Ukjent feil",
    logReportUpdated: "Rapport Oppdatert",
    logReportDeleted: "Rapport Slettet",
    logReportCreated: "Rapport Opprettet",
    logUpdatedReport: "Oppdaterte rapport",
    logDeletedReport: "Slettet rapport",
    logCreatedNewReport: "Opprettet ny rapport",
    violations: {
      title: "Regelbrudd",
      selectViolations: "Velg Regelbrudd",
      selectedViolations: "Valgte Regelbrudd",
      addViolations: "Legg til Regelbrudd",
      subtitle: "Klikk på regelbrudd for å velge dem til denne rapporten",
      types: {
        valueOfLife: "Value Of Life",
        powergaming: "Powergaming",
        metagaming: "Metagaming", 
        combatlogging: "Combat Logging",
        copbait: "Cop Baiting",
        vdm: "VDM (Vehicle Death Match)",
        rdm: "RDM (Random Death Match)",
        forceperm: "Force Perm",
        newLifeRule: "New Life Rule",
        greenzone: "Green Zone"
      }
    },
    // Form labels  
    reporterLabel: "Rapportør",
    playerLabel: "Spiller",
    discordIdLabel: "Discord ID",
    priorityLabel: "Prioritet",
    statusLabel: "Status",
    createdAtLabel: "Opprettet",
    descriptionLabel: "Beskrivelse",
    // Form actions
    linkReportsSubtitle: "Klikk på rapporter for å velge dem, og klikk deretter \"Legg til\" for å knytte dem til denne hendelsen",
    searchReportsPlaceholder: "Søk i rapporter etter emne, spiller eller rapportør...",
    noReportsToLink: "Ingen rapporter tilgjengelig å knytte til",
    noReportsMatchSearch: "Ingen rapporter samsvarer med søket ditt",
    add: "Legg til",
    selectedReports: "Valgte Rapporter",
    addReports: "Legg til {count} Rapport{plural}",
    cancel: "Avbryt",
    report: "Rapport",
    reports: "Rapporter",
    // Create/Edit form fields
    subjectLabel: "Emne",
    subjectPlaceholder: "Kort beskrivelse av problemet",
    descriptionPlaceholder: "Gi detaljert informasjon om hendelsen, inkludert når det skjedde, hva som skjedde, og andre relevante detaljer...",
    currentUserNote: "Du oppretter denne rapporten som den nåværende påloggede brukeren",
    playerNamePlaceholder: "Skriv inn spillernavn",
    discordIdPlaceholder: "123456789012345678",
    priorityLevels: {
      low: "Lav Prioritet",
      medium: "Middels Prioritet",
      high: "Høy Prioritet", 
      critical: "Kritisk Prioritet"
    },
    evidenceAttachments: "Beviser Vedlegg",
    dragDropFiles: "Dra og slipp filer her, eller klikk for å bla",
    supportedFiles: "Støttet: Bilder (PNG, JPG, GIF, WEBP), Tekstfiler (txt), Dokumenter (PDF, DOCX, ODT)",
    attachedFiles: "Vedlagte Filer",
    removeAttachment: "Fjern",
    reportStatus: "Rapport Status",
    keepOpenDefault: "Hold Åpen (Standard)",
    closeImmediately: "Lukk Umiddelbart",
    openStatusDescription: "Rapporten vil forbli åpen for videre etterforskning og oppfølging.",
    closedStatusDescription: "Rapporten vil bli merket som lukket umiddelbart etter opprettelse.",
    submitReport: "Send inn Rapport"
  },

  carVariationsEditor: {
    title: "Kjøretøyvariasjoner Editor",
    subtitle: "Rediger kjøretøyfargevariasjon og utseende",
    selected: "Valgt",
    basicInformation: "Grunnleggende informasjon",
    modelName: "Modellnavn",
    lightSettings: "Lysinnstillinger",
    sirenSettings: "Sireneinnstillinger",
    modelNamePlaceholder: "f.eks., nddexplorer",
    newVehicle: "Nytt kjøretøy",
    defaultModkit: "0_standard_modkit",
    colorNames: {
      primary: "Primær",
      secondary: "Sekundær",
      pearl: "Perle",
      wheel: "Hjul",
    }
  },

  dualFtpManager: {
    title: "Dual FTP Manager",
    subtitle: "Administrer filer mellom dev og prod servere",
    close: "Lukk",
    developmentServer: "Utviklingsserver",
    productionServer: "Produksjonsserver",
    connected: "Tilkoblet",
    disconnected: "Frakoblet",
    connecting: "Kobler til...",
    disconnect: "Koble fra",
    selectServer: "Velg FTP server...",
    connectToServer: "Koble til FTP server for å se filer",
    transferProgress: "Overfører",
    transferring: "fra",
    to: "til",
    instructions: "Koble til begge servere og dra filer eller mapper mellom panelene for å overføre handling.meta, kjøretøyfiler og hele mapper",
    dropFileHere: "Slipp filer eller mapper her for å overføre",
    overwriteConfirm: "Filen finnes allerede. Vil du overskrive den?",
    overwriteTitle: "Bekreft overskrivning",
    overwrite: "Overskriv",
    skip: "Hopp over",
    folderExists: "Mappen finnes allerede. Vil du slå sammen eller overskrive?",
    folderExistsTitle: "Mappen finnes allerede",
    merge: "Slå sammen",
    overwriteFolder: "Overskriv",
    copyingFolder: "Kopierer mappe",
    copyingFile: "Kopierer fil",
    folderCopied: "Mappe kopiert",
    fileCopied: "Fil kopiert",
    copyError: "Feil ved kopiering",
    searchPlaceholder: "Søk i alle mapper i",
    searchAllDirectories: "Søk i alle mapper",
    loadingDirectory: "Laster mappe...",
    cancel: "Avbryt",
    failedToOpenFile: "Kunne ikke åpne fil",
    failedToSaveFile: "Kunne ikke lagre fil",
    unknownError: "Ukjent feil",
    navigationCancelled: "Navigasjon avbrutt",
    navigationFailed: "Navigasjon feilet",
    transferError: "Overføringsfeil",
    ftpServerManager: "FTP Server Manager",
    devServer: "Dev Server",
    prodServer: "Prod Server",
    contextMenu: {
      openInEditor: "Åpne i",
      editor: "Editor",
      copyPath: "Kopier sti",
      copyFilename: "Kopier filnavn",
      size: "Størrelse",
      path: "Sti",
    },
  },

  fileExplorer: {
    createNewFolder: "Opprett ny mappe",
    uploadFile: "Last opp fil",
    downloadFile: "Last ned fil",
    delete: "Slett",
    readyToUpload: "Klar til å laste opp:",
    upload: "Last opp",
    cancel: "Avbryt",
    loadingFiles: "Laster filer...",
    noFilesFound: "Ingen filer funnet",
    folderEmpty: "Denne mappen er tom",
    unknownDate: "Ukjent dato",
    deleteConfirm: "Er du sikker på at du vil slette",
    deleteError: "Feil ved sletting:",
    unknownDeleteError: "Ukjent feil ved sletting",
    loadDirectoryError: "Ukjent feil ved lasting av mappe",
    uploadFileError: "Feil ved opplasting av fil",
    unknownUploadError: "Ukjent feil ved opplasting",
    downloadError: "Ukjent feil ved nedlasting",
    createFolderError: "Ukjent feil ved opprettelse av mappe",
  },

  ftpConnectionManager: {
    title: "FTP/SFTP Tilkoblinger",
    addServer: "Legg til Server",
    connectedTo: "Tilkoblet til",
    disconnect: "Koble fra",
    timeoutWarning: "Timeout-advarsel",
    noServersConfigured: "Ingen FTP-servere konfigurert",
    lastConnected: "Sist:",
    editServer: "Rediger server",
    deleteServer: "Slett server",
    connected: "Tilkoblet",
    connect: "Koble til",
    connecting: "Kobler til...",
    connectionFailed: "Tilkobling feilet",
    connectionFailedAlert: "Tilkobling feilet:",
    serverName: "Servernavn",
    serverType: "Servertype",
    developmentServer: "Utviklingsserver",
    productionServer: "Produksjonsserver",
    host: "Vert",
    port: "Port",
    username: "Brukernavn",
    password: "Passord",
    protocol: "Protokoll",
    passiveMode: "Passiv modus",
    useSSLTLS: "Bruk SSL/TLS",
    rememberPassword: "Husk passord",
    remotePath: "Ekstern sti",
    testConnection: "Test tilkobling",
    save: "Lagre",
    cancel: "Avbryt",
    update: "Oppdater",
    add: "Legg til",
    editServerTitle: "Rediger Server",
    addNewServerTitle: "Legg til Ny Server",
    noConnectionSelected: "Ingen FTP-tilkobling valgt",
    selectOrCreateConnection: "Velg eller opprett en FTP-tilkobling for å utforske filer",
    connectionFailedStatus: "Tilkobling mislyktes",
  },

  fxManifestEditor: {
    title: "FX Manifest Redigerer",
    visualEditor: "Visuell Redigerer",
    codeEditor: "Kode Redigerer",
    reset: "Tilbakestill",
    save: "Lagre",
    close: "Lukk",
    basicInformation: "Grunnleggende Informasjon",
    fxVersion: "FX Versjon",
    game: "Spill",
    author: "Forfatter",
    version: "Versjon",
    description: "Beskrivelse",
    authorPlaceholder: "Ditt navn",
    versionPlaceholder: "1.0.0",
    descriptionPlaceholder: "Ressursbeskrivelse...",
    files: "Filer",
    addFile: "Legg til Fil",
    dataFiles: "Data Filer",
    addDataFile: "Legg til Data Fil",
    clientScripts: "Klient Skript",
    addClientScript: "Legg til Klient Skript",
    serverScripts: "Server Skript",
    addServerScript: "Legg til Server Skript",
    sharedScripts: "Delte Skript",
    addSharedScript: "Legg til Delt Skript",
    dependencies: "Avhengigheter",
    addDependency: "Legg til Avhengighet",
    exports: "Eksporter",
    addExport: "Legg til Eksport",
    serverExports: "Server Eksporter",
    addServerExport: "Legg til Server Eksport",
    exportName: "Eksport Navn",
    exportDescription: "Eksport Beskrivelse",
    type: "Type",
    file: "Fil",
    preview: "Forhåndsvisning",
    codeEditorPlaceholder: "-- FxManifest.lua innhold...",
  },

  handlingEditor: {
    title: "Kjøretøy Håndtering Editor",
    subtitle: "Konfigurer kjøretøyfysikk og ytelse",
    close: "Lukk",
    save: "Lagre",
    reset: "Tilbakestill",
    import: "Importer",
    export: "Eksporter",
    tabs: {
      aero: "Aerodynamikk",
      chassis: "Chassis",
      engine: "Motor",
      transmission: "Girkasse",
      brakes: "Bremser",
      suspension: "Fjæring",
      traction: "Trekkraft",
      damage: "Skade",
      misc: "Diverse",
      raw: "Rå"
    },
    sections: {
      basic: "Grunnleggende egenskaper",
      advanced: "Avanserte innstillinger",
      physics: "Fysikk-egenskaper"
    },
    properties: {
      handlingName: "Håndteringsnavn",
      mass: "Masse (kg)",
      dragCoeff: "Luftmotstandskoeffisient",
      downforce: "Nedkraftmodifikator",
      windResistance: "Vindmotstand",
      downforceModifier: "Nedkraftmodifikator",
      driveForce: "Drivkraft",
      driveInertia: "Drivtreghet",
      maxFlatVel: "Maks flat hastighet",
      driveGears: "Drivgir",
      brakeForce: "Bremsekraft",
      brakeBiasFront: "Bremsehelling foran",
      handBrakeForce: "Håndbrekkkraft",
      steeringLock: "Styrelås",
      tractionCurveMax: "Trekkraft kurve maks",
      tractionCurveMin: "Trekkraft kurve min",
      tractionCurveLateral: "Trekkraft kurve lateral",
      tractionSpringDeltaMax: "Trekkraft fjær delta maks",
      lowSpeedTractionLossMult: "Lav hastighet trekkrafttap mult",
      camberStiffness: "Camber stivhet",
      tractionBiasFront: "Trekkraftshelling foran",
      tractionLossMult: "Trekkrafttap mult",
      suspensionForce: "Fjærkraft",
      suspensionCompDamp: "Fjær kompresjon demping",
      suspensionReboundDamp: "Fjær rekyl demping",
      suspensionUpperLimit: "Fjær øvre grense",
      suspensionLowerLimit: "Fjær nedre grense",
      suspensionRaise: "Fjærhøyde",
      suspensionBiasFront: "Fjærhelling foran",
      antiRollBarForce: "Anti-roll bar kraft",
      antiRollBarBiasFront: "Anti-roll bar helling foran",
      rollCentreHeightFront: "Rull senter høyde foran",
      rollCentreHeightRear: "Rull senter høyde bak",
      shiftTimeUp: "Gir opp tid",
      powerBias: "Kraftfordeling",
      tireGripMax: "Dekk grep maks",
      tireGripMin: "Dekk grep min",
      springStrength: "Fjærstyrke",
      compressionDamping: "Kompresjondemping",
      reboundDamping: "Rekyldempning"
    },
    descriptions: {
      aero: "Dette settet med verdier representerer kjøretøyets kroppsform, og påvirker hovedsakelig toppfartoppførsel.",
      chassis: "Dette settet med verdier representerer kjøretøykroppen selv, og vil spille en stor rolle på hvordan kjøretøyet oppfører seg totalt sett.",
      engine: "Den bevegelige kraften til kjøretøyet ditt, dette settet med verdier styrer detaljer om hvordan forskjellige deler av motoren vil oppføre seg. Fungerer i nært forhold til girkasse.",
      transmission: "Hvordan motoren overfører kraft til hjulene.",
      brakes: "Kjøretøyets stoppekraft og bremsefordeling.",
      traction: "Hvordan kjøretøyets dekk griper tak i veioverflaten.",
      downforceModifier: "Nedkraft er en måte å få grep ved hastighet, og kan økes med spoilere. I V er nedkraft representert som to oppførsler - en faktisk nedkraft som presser bilen ned, og et separat grepstak basert på fDownforceModifier og et regelsett.",
      windResistance: "Kjøretøyets kropps luftmotstand. Høyere motstand betyr tidligere opplevd krafttap ved høyere hastighet, noe som resulterer i lavere toppfart. Fungerer som en multiplikator, denne verdien definerer hvor mye luftmotstand vil skalere med hastighet.",
      mass: "Målt i kg, masse er kun ansvarlig for interaksjonen mellom enheter. Masse er ikke i det hele tatt relatert til fysisk smidighet og påvirker ikke bilens fysikk i det hele tatt. Påvirker kun hvor godt bilen klarer seg når den kolliderer med andre enheter.",
      power: "Også kalt motoreffekt, den dikterer målakselerasjonen motoren sikter mot, målt i G-krefter. Hjulgrep klarer kanskje ikke å takle det. Giring modulerer denne verdien i forhold for å oversette den til dreiemoment.",
      driveInertia: "Hvor responsiv motorturtallene vil være for gasspedalkontrollen. Høyere verdier resulterer i raskere RPM-akselerasjon og -retardasjon, mens lavere verdier resulterer i mer treg RPM.",
      topSpeed: "Maksimal motor toppfart. Over denne hastigheten vil motorkraften forringes sterkt. Husk at giring vil strekke seg over denne 'lengden'.",
      numberOfGears: "Antall gir på standard. Da gir modulerer fInitialDriveForce opp til fInitialDriveMaxFlatVel, anbefales det å holde et rimelig antall gir for toppfarten din. Husk at girkasseoppgraderinger legger til ett gir totalt.",
      powerBias: "Definerer hvordan kraften fra fInitialDriveForce fordeles mellom akslene. 0.0 innebærer en helt RWD-oppsett, som kun leverer kraft til bakhjulene.",
      brakeStrength: "Hvor mange G-er med retardasjon som påføres hvert hjul. fTractionCurveMax og fBrakeForce er nært beslektet. Forutsatt perfekt balanse, er en fjerdedel av bremsen nok til å få hvert hjul til å låse seg.",
      brakeBias: "Fordeling av bremsestyrken mellom akslene. Vanligvis er den beste balansen mellom 0.55 og 0.7 for beste bremseevner, da den tar hensyn til vektoverføringen som følger når man bremser.",
      handbrakeStrength: "Ligner på fBrakeForce, men påføres kun bakakselen(e).",
      tireGripMax: "Maksimum G-er kjøretøyets hjul kan trekke. I V er grep representert som hvor mye kjøretøyets dekk er i stand til å akselerere eller retardere bilens kropp, som helhet.",
      tireGripMin: "Minimum G-er kjøretøyets hjul kan trekke. Disse verdiene endres konstant av kontekst, som fjæringstrykk, overflaten dekket kjører på, etc.",
      tractionCurveLateral: "Glidevinkel hvor bilen vil nyte best tilgjengelige grep. Kjøretøyet vil ha en tendens til å holde seg under halvparten av denne verdien. Det anbefales å holde den på standard 22.5 på de fleste kjøretøy.",
      suspension: "Stivere, mykere, løs, stram. Denne seksjonen styrer hvordan bilen din flyter over hjulene sine.",
      springStrength: "Fjærstyrke.",
      compressionDamping: "Hvor sterkt fjærstyrken dempes ved komprimering.",
      reboundDamping: "Hvor sterkt fjærstyrken dempes ved dekomprimering.",
      raw: "Ikke rediger verdiene her. Dette området fungerer kun som en forhåndsvisning av filen."
    },
    labels: {
      rawData: "Rå data"
    },
    tooltips: {
      mass: "Kjøretøyvekt påvirker akselerasjon og håndtering",
      dragCoeff: "Luftmotstandskoeffisient (høyere = mer luftmotstand)",
      downforce: "Nedadgående kraft ved høye hastigheter for grep",
      driveForce: "Motorkraftlevering til hjul",
      brakeForce: "Maksimal bremsekraft",
      steeringLock: "Maksimal styrevinkel i grader"
    },
    presets: {
      title: "Kjøretøy Forhåndsinnstillinger",
      sports: "Sportsbil",
      muscle: "Muscle Car",
      suv: "SUV",
      truck: "Lastebil",
      motorcycle: "Motorsykkel",
      apply: "Bruk forhåndsinnstilling"
    },
    messages: {
      saved: "Håndteringskonfigurasjon lagret",
      loaded: "Håndteringskonfigurasjon lastet",
      resetConfirm: "Er du sikker på at du vil tilbakestille alle verdier?",
      invalidData: "Ugyldig håndteringsdata oppdaget",
      exportSuccess: "Håndteringsdata eksportert"
    }
  },
  
  txAdmin: {
    // Tab Labels
    overview: "Oversikt",
    players: "Spillere",
    resources: "Ressurser",
    console: "Konsoll",
    logs: "Logger",
    playerHistory: "Spillerhistorikk",
    
    // General UI
    processing: "Behandler...",
    connected: "Tilkoblet",
    connecting: "Kobler til",
    retry: "Prøv Igjen",
    refreshData: "Oppdater Data",
    checkAgain: "Sjekk Igjen",
    
    // Status Messages
    connectedSuccessfully: "Vellykket tilkoblet til TxAdmin-panel",
    attemptingConnection: "Forsøker å etablere tilkobling til TxAdmin-server",
    txAdminSetupRequired: "TxAdmin Oppsett Påkrevd",
    configureCredentials: "Konfigurer dine TxAdmin-legitimasjoner i Brukerinnstillinger for å få tilgang til panelet",
    credentialsRequired: "TxAdmin-legitimasjoner Påkrevd",
    needCredentialsDescription: "Du må konfigurere dine individuelle TxAdmin-legitimasjoner for å få tilgang til panelet.",
    goToUserSettings: "Gå til Brukerinnstillinger → TxAdmin for å konfigurere dine legitimasjoner.",
    rateLimited: "TxAdmin Ratebegrenset",
    rateLimitDescription: "Viser hurtigbufret data hvor tilgjengelig. Nye forespørsler vil være begrenset.",
    rateLimitedWait: "Ratebegrenset. Vennligst vent",
    minutes: "minutter før du prøver igjen",
    authenticationFailed: "Autentisering feilet",
    tooManyAttempts: "For mange påloggingsforsøk. Bruker mock data. Vennligst vent",
    cannotConnect: "Kan ikke koble til TxAdmin-server. Vennligst sjekk konfigurasjonen din.",
    failedToConnect: "Klarte ikke å koble til TxAdmin",
    txAdminRateLimited: "TxAdmin er ratebegrenset",
    notConnected: "Ikke tilkoblet TxAdmin",
    connectToViewLogs: "Koble til TxAdmin for å se serverlogger",
    logsWillAppear: "Sanntids serverlogger vil vises her når tilkoblet",
    connectToViewResources: "Koble til TxAdmin for å se serverressurser",
    resourcesWillAppear: "Serverressurser vil vises her når tilkoblet",
    connectToViewPlayers: "Koble til TxAdmin for å se spillerliste",
    playersWillAppear: "Spillere vil vises her når de kobler til serveren",
    serverControls: "Serverkontroller",
    
    // Overview Section
    activeResources: "Aktive Ressurser",
    playersOnline: "Spillere Online",
    serverPerformance: "Serverytelse",
    serverUptime: "Server Oppetid",
    capacity: "Kapasitet",
    runningSmoothly: "Kjører jevnt",
    zeroTickWarning: "0ms tick",
    
    // Resources Section
    loadingResources: "Laster ressurser...",
    noResources: "Ingen ressurser lastet",
    resourceName: "Ressursnavn",
    start: "Start",
    stop: "Stopp",
    restart: "Restart",
    started: "Startet",
    stopped: "Stoppet",
    starting: "Starter",
    stopping: "Stopper",
    restarting: "Restarter",
    
    // Players Section
    searchPlayers: "Søk spillere...",
    searchResults: "Søkeresultater",
    noPlayersFound: "Ingen spillere funnet som matcher søket ditt.",
    noPlayersOnline: "Ingen spillere online",
    playerDetails: "Spillerdetaljer",
    ping: "Ping",
    uptime: "Oppetid",
    license: "Lisens",
    identifiers: "Identifikatorer",
    warn: "Advar",
    kick: "Spark ut",
    ban: "Utesteng",
    message: "Melding",
    directMessage: "Direktemelding",
    selectAction: "Velg Handling",
    enterReason: "Skriv inn grunn...",
    reasonRequired: "Vennligst skriv inn en grunn",
    executeAction: "Utfør Handling",
    executingAction: "Utfører handling...",
    actionCompleted: "Handling fullført vellykket",
    actionFailed: "Handling mislyktes",
    reportPlayer: "Rapporter Spiller",
    
    // Console Section
    sendCommand: "Send Kommando",
    enterCommand: "Skriv inn kommando...",
    sendingCommand: "Sender kommando...",
    commandSent: "Kommando sendt vellykket",
    commandFailed: "Kunne ikke sende kommando",
    serverConsole: "Serverkonsoll",
    
    // Logs Section
    serverLogs: "Serverlogger",
    loadingLogs: "Laster logger...",
    noLogs: "Ingen logger tilgjengelig",
    timestamp: "Tidsstempel",
    level: "Nivå",
    logMessage: "Melding",
    
    // History Section
    searchDatabase: "Søk Database",
    searchByNameOrLicense: "Søk etter navn eller lisens...",
    searchingDatabase: "Søker i database...",
    playerHistoryDetails: "Spillerhistorikk Detaljer",
    filterPlayers: "Filtrer Spillere",
    sortPlayers: "Sorter Spillere",
    allPlayers: "Alle Spillere",
    onlinePlayers: "Online Spillere",
    offlinePlayers: "Offline Spillere",
    mostRecent: "Nyeste",
    oldest: "Eldste",
    alphabetical: "Alfabetisk",
    mostConnections: "Flest Tilkoblinger",
    lastSeen: "Sist Sett",
    totalConnections: "Totale Tilkoblinger",
    firstSeen: "Først Sett",
    loadingHistory: "Laster historikk...",
    noHistoryFound: "Ingen spillerhistorikk funnet",
    viewDetails: "Vis Detaljer",
    closeDetails: "Lukk Detaljer",
    
    // Announcements
    sendAnnouncement: "Send Kunngjøring",
    sendAnnouncementToAllPlayers: "Send en kunngjøring til alle påloggede spillere",
    announcementPlaceholder: "Skriv din kunngjøring her...",
    announcementTextRequired: "Vennligst skriv en kunngjøringsmelding",
    sendingAnnouncement: "Sender kunngjøring...",
    announcementSent: "Kunngjøring sendt!",
    announcementFailed: "Kunne ikke sende kunngjøring",
    
    // Common Status
    online: "Online",
    offline: "Offline",
    unknown: "Ukjent",
    status: "Status",
    version: "Versjon",
    startResource: "Start ressurs",
    stopResource: "Stopp ressurs",
    restartResource: "Restart ressurs",
    warnPlayer: "Advar spiller",
    kickPlayer: "Spark ut spiller",
    banPlayer: "Utesteng spiller", 
    sendMessage: "Send melding",
    target: "Mål",
    reason: "Årsak",
    duration: "Varighet",
    enterReasonFor: "Angi årsak for",
    oneHour: "1 time",
    sixHours: "6 timer",
    twelveHours: "12 timer",
    oneDay: "1 dag",
    threeDays: "3 dager",
    oneWeek: "1 uke",
    oneMonth: "1 måned",
    permanent: "Permanent",
    enterMessageToPlayer: "Skriv melding til spiller",
    cancel: "Avbryt",
    createNewAdmin: "Opprett ny admin",
    username: "Brukernavn",
    enterUsername: "Skriv inn brukernavn",
    fivemIdPlaceholder: "Skriv inn FiveM ID (valgfri)",
    discordIdPlaceholder: "Skriv inn Discord ID (valgfri)",
    permissions: "Tilganger",
    creating: "Oppretter...",
    createAdmin: "Opprett admin",
    adminCreatedSuccessfully: "Admin opprettet vellykket",
    importantInformation: "Viktig informasjon",
    passwordOnlyShownOnce: "Dette passordet vises kun én gang. Sørg for å kopiere og lagre det trygt!",
    temporaryPassword: "Midlertidig passord",
    instructionsForNewAdmin: "Instruksjoner for ny admin",
    loginInstruction: "Logg inn på txAdmin med dette brukernavnet og passordet",
    changePasswordFirstLogin: "Bytt passord umiddelbart etter første innlogging",
    chooseStrongPassword: "Velg et sterkt, unikt passord",
    keepCredentialsPrivate: "Hold påloggingsinformasjon privat og sikker",
    copyAll: "Kopier alt",
    close: "Lukk",
    sendAnnouncementToAll: "Send kunngjøring til alle spillere",
    announcementInfo: "Informasjon om kunngjøringer og meldinger",
    actions: "Handlinger",
    
    // CFG Editor
    serverConfigurationEditor: "Serverkonfigurasjon Editor",
    savingFile: "Lagrer...",
    cfgSavedSuccessfully: "server.cfg fil lagret vellykket",
    failedToLoadCfg: "Kunne ikke laste server.cfg fil",
    failedToSaveCfg: "Kunne ikke lagre server.cfg fil",
    saveFileShortcut: "Lagre Fil (Ctrl+S)",
    saveFileShortcutDesc: "Lagre fil",
    cfgPlaceholder: "# Serverkonfigurasjonsfil\n# Legg til server.cfg innhold her...",
    keyboardShortcuts: "Tastatursnarveier:",
    insertSpaces: "Sett inn 4 mellomrom",
    cfgEditorHelpText: "Endringer vil bli sikkerhetskopiert automatisk før lagring. Sørg for å teste konfigurasjonendringene dine før du starter serveren på nytt."
  },

  // FiveM Vehicle Handler
  fiveMVehicleHandler: {
    blueLight: "Blått lys",
    redLight: "Rødt lys",
    whiteLight: "Hvitt lys", 
    blackLight: "Svart lys",
    customColor: "Tilpasset farge",
    sirenIndex: "Sirene",
    setToColor: "satt til {color}",
    colorAppliedTo: "{color} brukt på {count} sirener",
    newSirenAdded: "Ny sirene lagt til (Totalt: {count})",
    sirenRemoved: "Sirene {index} fjernet",
    sirenSettings: "Sireneinnstillinger",
    fileStructureAnalysis: "Filstrukturanalyse",
    foundSirenConfigurations: "Fant {count} sirenekonfigurasjoner",
    clickToApplyColorAll: "Klikk for å bruke farge på alle sirener:",
    redBlueAlternate: "Rød/Blå veksling",
    sirenConfigurations: "Sirenekonfigurasjoner",
    addNewSiren: "Legg til ny sirene",
    removeSiren: "Fjern sirene",
    noSirensFound: "Ingen sirener funnet i denne filen",
    
    // Missing translations for CarcolsEditor
    orangeLight: "Oransje lys",
    orangeEmergencyLight: "Oransje lys - Berging/vedlikehold",
    carcolsEditor: "Carcols Editor",
    close: "Lukk",
    quickColorSettings: "Hurtige fargeinnstillinger",
    blueOnly: "Kun blå",
    redOnly: "Kun rød",
    orangeOnly: "Kun oransje",
    redBlueMix: "Rød + Blå",
    individualConfiguration: "Konfigurasjon for nødlys på kjøretøy - kan endres individuelt",
    colorLabel: "Farge",
    blueShort: "Blå",
    redShort: "Rød",
    orangeShort: "Oransje",
    intensity: "Intensitet",
    coronaSize: "Corona størrelse",
    coronaIntensity: "Corona intensitet",
    flash: "Blink",
    light: "Lys",
    spotlight: "Spotlight",
    rotate: "Roter",
    tipsTitle: "Tips",
    tipsText: "Intensitet kontrollerer lysstyrke (0.0-10.0), Corona størrelse kontrollerer glød-effekt (0.0-2.0), Corona intensitet kontrollerer glød-styrke (0-100)."
  },

  todoCategories: {
    title: "Todo Kategorier",
    description: "Administrer kategorier for Todo-oppgaver med rolle-basert tilgang",
    newCategory: "Ny Kategori",
    editCategory: "Rediger Kategori",
    name: "Navn",
    nameRequired: "Navn *",
    namePlaceholder: "Skriv kategori navn...",
    categoryDescription: "Beskrivelse",
    descriptionPlaceholder: "Skriv beskrivelse (valgfritt)...",
    parentCategory: "Foreldrekategori",
    noParentCategory: "Ingen foreldrekategori",
    color: "Farge",
    colorTooltip: "Velg farge",
    visibleToRoles: "Synlig for roller",
    visibleToRolesRequired: "Synlig for roller *",
    inheritanceInfo: "📋 Arv av tilganger: Denne underkategorien arver automatisk tilgangene fra foreldrekategorien. Du kan legge til ekstra roller ved å krysse av for flere.",
    createSubcategory: "Opprett underkategori",
    edit: "Rediger",
    delete: "Slett",
    cancel: "Avbryt",
    save: "Lagre",
    updating: "Oppdaterer...",
    creating: "Oppretter...",
    createCategory: "Opprett Kategori",
    updateCategory: "Oppdater Kategori",
    deleteConfirmation: "Er du sikker på at du vil slette kategorien",
    deleteWithChildren: "sammen med alle underkategorier",
    deleteWithTodos: "Dette vil også slette alle tilknyttede todos",
    deleteSuccess: "Kategori slettet",
    deleteError: "Feil ved sletting av kategori",
    createSuccess: "Kategori opprettet",
    updateSuccess: "Kategori oppdatert",
    createError: "Feil ved opprettelse av kategori",
    updateError: "Feil ved oppdatering av kategori",
    loading: "Laster kategorier...",
    noCategories: "Ingen kategorier funnet. Opprett din første kategori for å komme i gang.",
    subcategory: "underkategori",
    mainCategory: "Hovedkategori",
    newSubcategory: "Ny Underkategori under",
    cannotDeleteHasTodos: "Kan ikke slette - har",
    deleteCategory: "Slett kategorien",
    tasksAttached: "oppgaver tilknyttet",
    andSubcategories: "og underkategorier",
    subcategoriesWillBeDeleted: "underkategorier som også vil bli slettet",
    createFirstCategory: "Opprett første kategori",
    tasks: "oppgaver",
    roles: {
      veriagent: "Veriagent",
      moderator: "Moderator",
      developers: "Utviklere",
      admin: "Admin",
      superAdmin: "Super Admin",
      veriagentDesc: "Grunnrolle for verifikasjonsagenter",
      moderatorDesc: "Fellesskapsmoderatorer med utvidede tillatelser",
      developersDesc: "Tekniske teammedlemmer og utviklere", 
      adminDesc: "Systemadministratorer med full tilgang",
      superAdminDesc: "Høyeste nivå administratorer med alle tillatelser"
    }
  }
};
